// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_VERSION = "version"; // Count: 6
export var _DYN_QUEUE = "queue"; // Count: 6
export var _DYN_CONNECTION_STRING = "connectionString"; // Count: 4
export var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 5
export var _DYN_USER_OVERRIDE_ENDPOI0 = "userOverrideEndpointUrl"; // Count: 6
export var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 5
export var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
export var _DYN_CONTEXT = "context"; // Count: 5
export var _DYN_ADD_HOUSEKEEPING_BEF1 = "addHousekeepingBeforeUnload"; // Count: 2
export var _DYN_SEND_MESSAGE = "sendMessage"; // Count: 3
export var _DYN_UPDATE_SNIPPET_DEFIN2 = "updateSnippetDefinitions"; // Count: 2
//# sourceMappingURL=__DynamicConstants.js.map